<template>
  <v-container class="ma-0 pa-0">
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>Add an Organization</v-card-title>
      <v-form
        ref="form"
        v-model="valid"
        @submit.prevent="submit"
      >
        <v-card-text>
          <v-text-field
            v-model="name"
            label="Name"
            clearable
            :rules="nameRules"
          />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="cancel">Cancel</v-btn>
          <v-btn color="primary" text @click="submit">Add</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AddOrganizationModal',

  data: () => ({
    valid: false,
    name: '',
    nameRules: [v => !!v || 'Name is required']
  }),
  methods: {
    ...mapActions(['requestCreateOrganization']),

    submit () {
      if (this.$refs.form.validate()) {
        this.requestCreateOrganization(this.name)
        this.$emit('close')
        this.$refs.form.reset()
      }
    },
    cancel () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="sass" scoped>
.v-settings
  .v-item-group
    cursor: pointer

    &__item
      border-width: 3px
      border-style: solid
      border-color: transparent !important

      &--active
        border-color: #00cae3 !important
</style>
